import styled from 'styled-components/macro';

const SillImage = styled.img`
	width: 60%;
	height: 60%;
	object-fit: contain;
`;

export default SillImage;
